
 
jQuery(function($) {
	jQuery(document).ready(function() {

		// Hamburger Menu
			var $hamburger = $(".hamburger");
			$hamburger.on("click", function(e) {
				$hamburger.toggleClass("is-active");
				$('.block-site-search').removeClass('is-active');
				// Toggle Main Nav sticky
				if($($hamburger).hasClass('is-active')) {
					$('header.header').addClass('is-active');
				} else {
					$('header.header').removeClass('is-active');
				}
				//$('header.header').toggleClass('is-active');
			});
			
			
		
		// Ripple
		function createRipple() {
			
		}
		var $ripple = $('.js-ripple');

		$ripple.on('click.ui.ripple', function(e) {
		
			var $this = $(this);
			var $offset = $this.parent().offset();
			var $circle = $this.find('.c-ripple__circle');
			
			var x = e.pageX - $offset.left;
			var y = e.pageY - $offset.top;
			
			$circle.css({
			  top: y + 'px',
			  left: x + 'px'
			});
			
			$this.addClass('is-active');
		
		});
		
		$ripple.on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', function(e) {
			$(this).removeClass('is-active');
		});

		
			
			
		
			
			
			
		
		
			 
		// Header Stick
			$(document).on('scroll', function () {
				// if the scroll distance is greater than 100px
				if ($(window).scrollTop() > 40) {
					// console.log('heylldidf');
					$('.head-stick').addClass('pinned');
					$('.main-border').addClass('pinned');
				} else {
					$('.head-stick').removeClass('pinned');
					$('.main-border').removeClass('pinned');
				}
			});
				
	});
});